import { TFunction } from "i18next";

export interface TutorialConfig {
  moduleName: string;
  stepsCount: number;
  translationKey: string;
}

export const TUTORIAL_MODULES: Record<string, TutorialConfig> = {
  home: {
    moduleName: "tutorial.modules.home",
    stepsCount: 5,
    translationKey: "tutorial.home",
  },
  availability: {
    moduleName: "tutorial.modules.availability",
    stepsCount: 4,
    translationKey: "tutorial.availability",
  },
  workplan: {
    moduleName: "tutorial.modules.workPlan",
    stepsCount: 2,
    translationKey: "tutorial.workPlan",
  },
  holiday: {
    moduleName: "tutorial.modules.holiday",
    stepsCount: 2,
    translationKey: "tutorial.holiday",
  },
  rate: {
    moduleName: "tutorial.modules.rate",
    stepsCount: 2,
    translationKey: "tutorial.rate",
  },
  submittingComments: {
    moduleName: "tutorial.modules.submittingComments",
    stepsCount: 1,
    translationKey: "tutorial.submittingComments",
  },
  announcements: {
    moduleName: "tutorial.modules.announcements",
    stepsCount: 1,
    translationKey: "tutorial.announcements",
  },
  documents: {
    moduleName: "tutorial.modules.documents",
    stepsCount: 3,
    translationKey: "tutorial.documents",
  },
};

export const getTutorialSteps = (
  moduleKey: string,
  t: TFunction,
  includeImages = false
) => {
  const config = TUTORIAL_MODULES[moduleKey];

  if (!config) {
    // console.warn(`Tutorial configuration not found for module: ${moduleKey}`);
    return [];
  }

  return Array.from({ length: config.stepsCount }, (_, i) => ({
    title: "",
    content: "",
    stepKey: `${config.translationKey}.step${i + 1}`,
    area: t(config.moduleName),
    ...(includeImages && {
      image: `/images/tutorial/${moduleKey}/step${i + 1}.png`,
    }),
  }));
};
